import { distinct, paint } from "../../graph/aggregate.ts";
import type { ConnectedNode, Node } from "../../graph/types.ts";
import { isNode } from "../../graph/types.ts";
import type {
  AssessmentReducer,
  PrivilegeAggregate,
} from "../../types/assessment/data/aggregates.ts";
import type { AssessmentNodes } from "../../types/assessment/data/index.ts";

export const grantAggregate: AssessmentReducer<
  Node<AssessmentNodes, "grant">[]
> = distinct(
  "grant",
  (node) => node,
  (node) => node.key
);

export const privilegeAggregate: AssessmentReducer<PrivilegeAggregate> = paint(
  (n) => (isNode("usage")(n) ? n.data.type : undefined),
  distinct(
    "privilege",
    (node) => node as ConnectedNode<AssessmentNodes, "privilege">,
    (node) => node.key
  )
);

export const keyAggregate = <K extends keyof AssessmentNodes>(
  key: K
): AssessmentReducer<(AssessmentNodes[K] & { id: string })[]> =>
  distinct(
    key,
    (node) => ({ id: node.key, ...node.data }),
    (node) => node.id
  );
